module.exports = __webpack_public_path__ + "static/media/btn_apple_en.638c4027.svg";